import styles from '../../index.module.scss';
import type { TimeRuleChat } from '../useTimeRuleChat';

export default function HandedOffCard({ chat }: { chat: TimeRuleChat }) {
	const { mode, details } = chat;
	return (
		<div className={styles['action-card']}>
			{mode === 'edit'
				? '✓ Opened that rule in Settings → Time Rules.'
				: `✓ Opened the ${details.ruleType} rule form in Settings → Time Rules${
					details.name ? ` for “${details.name}”` : ''
				}. Set the criteria and details there, then Save.`}
		</div>
	);
}
